import { styled } from '@mui/material/styles';

import { Typography } from '@mui/material';

const StyledH1 = styled(Typography)(
  ({ theme }) => `
    margin: ${theme.DS_spacing(['xlx'])} 0 ${theme.DS_spacing(['md'])} 0;

    ${theme.breakpoints.up('md')} {
       margin: ${theme.DS_spacing(['xxl'])} 0 ${theme.DS_spacing(['lg'])} 0;
    }
  `,
);

export { StyledH1 };
